export const SYNC_STATUSES = {
    success: 'Success',
    failure: 'Failure'
};